import App from 'App';
import {ComponentType} from 'react';

function connectWithApp<TProps>(Component: ComponentType<TProps>) {
    return {
        App,
        Component,
    };
}

export default connectWithApp;
